import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const MapMarker = createSvgIcon(
  () => (
    <path d="M16.7969 49.0234C17.6758 50.3906 19.7266 50.3906 20.6055 49.0234C34.8633 28.5156 37.5 26.3672 37.5 18.75C37.5 8.39844 29.1016 0 18.75 0C8.30078 0 0 8.39844 0 18.75C0 26.3672 2.53906 28.5156 16.7969 49.0234ZM18.75 26.5625C14.3555 26.5625 10.9375 23.1445 10.9375 18.75C10.9375 14.4531 14.3555 10.9375 18.75 10.9375C23.0469 10.9375 26.5625 14.4531 26.5625 18.75C26.5625 23.1445 23.0469 26.5625 18.75 26.5625Z" />
  ),
  '0 0 38 51'
);
